import { useCallback, useRef, useState } from "react"
import { appApi, ClientSummary } from "../../../apis/appApi"

export function useClientSearch() {
  const [trigger] = appApi.endpoints.getClients.useLazyQuery()
  const [results, setResults] = useState<ClientSummary[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const search = useCallback(
    (query: string) => {
      if (timerRef.current) clearTimeout(timerRef.current)

      if (query.trim().length < 3) {
        setResults([])
        setIsLoading(false)
        return
      }

      setIsLoading(true)
      timerRef.current = setTimeout(async () => {
        try {
          const res = await trigger(
            { search: query.trim(), pageSize: 10 },
            true,
          ).unwrap()
          setResults(res.data)
        } catch {
          setResults([])
        } finally {
          setIsLoading(false)
        }
      }, 400)
    },
    [trigger],
  )

  const clear = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    setResults([])
    setIsLoading(false)
  }, [])

  return { results, isLoading, search, clear }
}
